import VideoBeingVerifiedModalComponent from "./VideoBeingVerifiedModalComponent";

export default VideoBeingVerifiedModalComponent;